import { default as domainCourse } from './course/services'
import { default as domainCourseCluster } from './cluster/services'

export default {
    domainCourse,
    domainCourseCluster
}